
import React from 'react';
import { Button } from '@/components/ui/button';
import { GitCompare } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

interface CompareCompanyButtonProps {
  companyName: string;
}

const CompareCompanyButton: React.FC<CompareCompanyButtonProps> = ({ companyName }) => {
  const navigate = useNavigate();

  const handleCompareClick = () => {
    // Navigate to comparison page with the current company pre-filled
    navigate(`/compare?company1=${encodeURIComponent(companyName)}`);
  };

  return (
    <Button
      onClick={handleCompareClick}
      variant="outline"
      size="sm"
      className="flex items-center gap-1.5 text-xs"
    >
      <GitCompare className="w-3 h-3" />
      Compare This Company
    </Button>
  );
};

export default CompareCompanyButton;
